import React, { useEffect } from "react";
import clsx from "clsx";
import { makeStyles } from "@material-ui/core/styles";
import Drawer from "@material-ui/core/Drawer";
import Button from "@material-ui/core/Button";
import List from "@material-ui/core/List";
import Divider from "@material-ui/core/Divider";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import InboxIcon from "@material-ui/icons/MoveToInbox";
import MailIcon from "@material-ui/icons/Mail";
import { useState } from "react";
import ReusableTable from "./ReusableTable";
import axios from "axios";

const useStyles = makeStyles({
  list: {
    width: 250,
  },
  fullList: {
    width: "auto",
  },
});

export default function EKYCHistory() {
  const classes = useStyles();
  const [open, setOpen] = useState(false);
  const [filterData, setFilterData] = useState([]);

  useEffect(() => {
    fetchTableData();
  }, []);

  const fetchTableData = async () => {
    try {
      const response = await axios.get(
        `${
          process.env.REACT_APP_API_URL
        }/api/ekyc/v1/validation-lead?status=approved&status=rejected&status=revalidated&page=${0}&limit=${100}`,
        {
          headers: {
            Authorization:
              "Bearer " + JSON.parse(localStorage.getItem("currUserToken")),
          },
        }
      );

      setFilterData(response.data.data);

      // Extract pagination info from the response
    } catch (error) {
      console.error(`Error fetching table data f:`, error);
    }
  };

  const toggleDrawer = () => setOpen(!open);

  return (
    <div>
      <Button onClick={toggleDrawer}>{"History"}</Button>
      <Drawer anchor={"right"} open={open} onClose={toggleDrawer}>
        <div>
          <ReusableTable
            columns={[
              "Wallet",
              "Name",
              "Address",
              "Thana",
              "District",
              "Action",
            ]}
            data={filterData.map((rowData) => ({
              Wallet: rowData.lead_number,
              Name: rowData.lead_name,
              District: rowData.district,
              Thana: rowData.thana,
              Address: rowData.address,
              ...rowData,
              Action: <button className="assign-button">Assign</button>,
            }))}
            mode="unassigned"
          />
        </div>
      </Drawer>
    </div>
  );
}
